export default __webpack_public_path__ + "static/media/Clan Bound Greaves of the Far Horizon.6bcbe185.jpg";